import styled from 'styled-components';

import { PAGE_MAX_WIDTH } from '../styles/constants';

export default function CompanyLogoHeader({ url, logo, id, height }) {
  return (
    <Wrapper id={id} height={height}>
      <div>
        <a href={url}>{logo && <img id="company-logo" src={logo} alt="logo" />}</a>
        <div id="language-flags" />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: ${(p) => p.theme.white};
  display: flex;
  align-items: center;
  height: 64px;
  flex-shrink: 0;

  > div {
    display: flex;
    align-items: center;
  }

  > div a {
    line-height: 0px;
  }

  #language-flags {
    margin-left: 32px;
  }
  > div {
    max-width: ${PAGE_MAX_WIDTH};
    width: 100%;
    margin: 0 auto;
    justify-content: space-between;

    @media (max-width: 1280px) {
      padding: 0 20px;
    }

    #company-logo {
      max-height: ${(p) => p.height}px;
      @media (max-width: 1180px) {
        max-width: 100%;
        display: block;
      }
    }
  }
`;
